<template>
  <section>
    <b-form>
      <b-form-input class="i-100" v-model="searchText" :placeholder="$t('SEARCH')"></b-form-input>
    </b-form>

    <div class="clearfix documentTitle">
      <div class="information w-light d-none d-lg-table-cell">
        <span class="d-none d-lg-block">{{ $t('DOCUMENT.NAME') }}</span>
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell">
        <span>{{ $t('DCLIDENTITY') }}</span>
      </div>
      <div class="information w-light d-none d-lg-table-cell">
        <span>{{ $t('TEAM.TITLE') }}</span>
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell">
        <span>{{ $t('DOCUMENT.PUBLISHED') }}</span>
      </div>
    </div>

    <b-card no-body class="mt-2">
      <ledger-item v-for="item in items" :item="item" :small="0" :key="item.document.id" />
    </b-card>
    <b-card v-if="items.length === 0" no-body class="mt-2">
      <b-card-body class="m-4">{{ $t('DOCUMENTS.NO_DOCUMENTS')}}</b-card-body>
    </b-card>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="limit"
      align="center"
      @input="getPublished"
    >
      <template v-slot:first-text>{{$t("PAGINATION.FIRST")}}</template>
      <template v-slot:prev-text>{{$t("PAGINATION.PREV")}}</template>
      <template v-slot:next-text>{{$t("PAGINATION.NEXT")}}</template>
      <template v-slot:last-text>{{$t("PAGINATION.LAST")}}</template>
    </b-pagination>
  </section>
</template>
<script>
import LedgerItem from "@/components/Ledger/LedgerItem";
export default {
  components: {
    LedgerItem
  },
  data() {
    return {
      currentPage: 1,
      limit: 7,
      items: [],
      totalItems: 0,
      searchText: "",
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    getPublished: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/documents/public/list", {
          page: this.currentPage,
          limit: this.limit,
          searchText: this.searchText
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  watch: {
    searchText: function() {
      if (this.searchText.length == 0) {
        this.getPublished();
      }
      if (this.searchText.length >= 3) {
        this.getPublished();
      }
    }
  },
  mounted: function() {
    this.getPublished();
  }
};
</script>
<style>
</style>
